import { render, staticRenderFns } from "./ProductCardDetails.vue?vue&type=template&id=9a1727dc&scoped=true&"
import script from "./ProductCardDetails.vue?vue&type=script&lang=js&"
export * from "./ProductCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardDetails.vue?vue&type=style&index=0&id=9a1727dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1727dc",
  null
  
)

export default component.exports